import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FullScreenLayoutComponent } from './layouts/full-screen-layout/full-screen-layout.component';

const routes: Routes = [
  // Redirect root to dashboard
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  // Standalone public routes
  // {
  //   path: 'login-get-support',
  //   component: GetSupportComponent
  // },
  // Protected Main Layout
  {
    path: '',
    component: FullScreenLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/full-screen-layout/full-screen-layout.module').then(m => m.FullScreenLayoutModules)
      }
    ]
  },
  // {
  //   path: '**',
  //   component: PageNotFoundComponent // Page not found 404
  // }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    urlUpdateStrategy: 'deferred',
    useHash: true,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
